/* eslint-disable no-tabs */
import { useSelector } from 'react-redux';
import useConditions from '../../../conditions';
import useUser from '../../../user';
import JUMP_CONDITION_TYPES from './types';

const useJump = () => {
  const { evaluate } = useConditions();
  const user = useSelector(state => state.User);
  const { accountExistsWithEmail } = useUser();

  /*
    determine the step within the action, to jump to, after evaluating any conditions

        jumpNextStep - the step to jump to if no value in jumpCondition
        jumpConditionalNextStep: the step to jump to if the condition is matched

  */
  const jump = async ({
    page,
    step,
    sequence,
    history,
    documents,
    selections,
    local,
    data
  }) => {
    const condition = {
      conditionType: step.jumpConditionType,
      conditionValueSource: step.jumpConditionValueSource,
      conditionValueDataLinkId: step.jumpConditionValueDataLinkId,
      conditionValueDataLinkField: step.jumpConditionValueDataLinkField,
      conditionDataLinkId: step.jumpConditionDataLinkId,
      conditionDataLinkField: step.jumpConditionDataLinkField,
      conditionDataLinkOperator: step.jumpConditionDataLinkOperator,
      conditionDataLinkValue: step.jumpConditionDataLinkValue,
      conditionJson: step.jumpConditionJson,
      conditionClaimName: step.jumpConditionClaimName,
      conditionLocalValueField: step.jumpConditionLocalValueField,
      conditionLocalField: step.jumpConditionLocalField,
      conditionLocalOperator: step.jumpConditionLocalOperator,
      conditionLocalValue: step.jumpConditionLocalValue,
      conditionStaticValue: step.jumpConditionStaticValue,
      conditionFields: step.fields
    };

    if (data?.value) {
      condition.conditionStaticValue = data.value;
    }

    if (!step.jumpConditionType) {
      return {
        result: step.jumpNextStep
      };
    }

    if (step.jumpConditionType === JUMP_CONDITION_TYPES.HAS_UNIQUE_EMAIL) {
      if (!local?.newUser?.email?.trim().length > 0) {
        return { error: 'no email found in local.newUser.email to check' };
      }
      const alreadyExists = await accountExistsWithEmail(local?.newUser?.email);
      if (alreadyExists.error) {
        return { error: alreadyExists.error };
      }
      return !alreadyExists ? step.jumpConditionalNextStep : step.jumpNextStep;
    } else if (
      step.jumpConditionType === JUMP_CONDITION_TYPES.CODE_RETURNS_TRUE
    ) {
      try {
        // eslint-disable-next-line
        const computeFunction = new Function(
          'page',
          'step',
          'sequence',
          'history',
          'selections',
          'documents',
          'local',
          'user',
          'data',
          step.jumpConditionFunctionCode
        );
        const functionResult = computeFunction(
          page,
          step,
          sequence,
          history,
          selections,
          documents,
          local,
          user,
          data
        );

        return functionResult === true
          ? step.jumpConditionalNextStep
          : step.jumpNextStep;
      } catch (error) {
        return { error };
      }
    }

    const result = await evaluate({
      condition,
      dataLinks:
        page.dataLinks?.map(pageDataLink => pageDataLink.dataLink) || [],
      documents,
      selections,
      local
    });

    if (result.error) {
      return { error: true, message: result.error };
    }

    return result.matched || result === true
      ? step.jumpConditionalNextStep
      : step.jumpNextStep;
  };

  return {
    jump
  };
};

export default useJump;
